import React, { FunctionComponent } from 'react';

import AppPage from '@/ui/AppPage/AppPage';
import MapCentricPage from '@/ui/MapCentric/MapCentricPage';
import Permissions from '@/lib/permissions';
import modelPPRegistar from '@/models/pp_registar';

const PPRegistarMapCentricPage: FunctionComponent = () => (
  <AppPage titlett="pp:page.registar" needPermission={[Permissions.PPRegistarView]}>
    <MapCentricPage
      model={modelPPRegistar}
      titleToken="pp:titles.registar"
      view="default"
      baseRecordPath={modelPPRegistar.apiPath}
      mapId={72}
      mapModel={modelPPRegistar}
      allowView
      allowExport
    />
  </AppPage>
);

export default PPRegistarMapCentricPage;
